import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'outline' | 'white';
  fullWidth?: boolean;
  showArrow?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  showArrow = true,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-sans font-bold uppercase tracking-wider px-8 py-4 transition-all duration-200 border-2 rounded-full hover:scale-[1.02] active:scale-[0.98]';
  const variants = {
    primary: 'bg-pitahaya border-pitahaya text-white hover:bg-pitahaya-dark hover:border-pitahaya-dark shadow-lg shadow-pitahaya/30',
    outline: 'bg-transparent border-pitahaya text-pitahaya hover:bg-pitahaya hover:text-white',
    white: 'bg-white border-white text-bunker hover:bg-gray-100 hover:border-gray-100'
  };
  const widthStyle = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${widthStyle} ${className}`} {...props} data-id="element-9">
      {children}
      {showArrow && <ArrowRight className="ml-2 h-5 w-5" data-id="element-10" />}
    </button>;
}